import genericStore from "../generic_store";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
import axios from "axios";
export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "app_ads",
    object: "app_ad",
    header: [
      { text: "Mensaje", value: "message" },
      { text: "Oculto", value: "hidden" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    updateItem({ commit, state }, data) {
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true,
        });
        axios
          .put(config.api_url + state.endpoint + "/" + data.id, formData)
          .then((response) => {
            commit("success");
            resolve();
          })
          .catch((error) => {
            reject();
          });
      });
    },
  },
  getters: {
    ...genericStore.getters
  }
};
